import AppliedApplicationTemplateModel from '../../../shared/models/templating/api/AppliedApplicationTemplateModel';
import TemplateFormFieldValueModel from '../../../shared/models/templating/api/TemplateFormFieldValueModel';

export interface MultilingualTemplateUpdate {
    appliedTemplateId: string;
    fieldValues: TemplateFormFieldValueModel[];
}

export const getMultilingualTemplateUpdates = (templates: AppliedApplicationTemplateModel[]): MultilingualTemplateUpdate[] => {
    const updates: MultilingualTemplateUpdate[] = [];
    (templates || []).forEach(template => {
        let fieldValues = [...(template.templateFormFieldValues || [])];
        let found = false;
        (template.templateForm?.templateFormSections || []).forEach(section => {
            const fields = section.dynamicFormFields?.length ? section.dynamicFormFields : section.templateFormFields;
            (fields || []).filter(field => field.associatedVariable === '{Multilingual}').forEach(field => {
                if (!field.name && !field.id) return;
                const matchesField = (value: TemplateFormFieldValueModel) => field.name
                    ? value.dynamicFormFieldName === field.name
                    : value.templateFormFieldId === field.id;
                const existing = fieldValues.find(matchesField)
                    || fieldValues.find(value => value.associatedVariable === '{Multilingual}' && !value.templateFormFieldId && !value.dynamicFormFieldName);
                const updated: TemplateFormFieldValueModel = {
                    ...existing,
                    ...(field.name ? { dynamicFormFieldName: field.name, dynamicFormFieldId: field.id } : { templateFormFieldId: field.id }),
                    appliedApplicationTemplateId: template.id,
                    associatedVariable: '{Multilingual}',
                    fieldType: field.fieldType,
                    value: 'true'
                };
                const index = fieldValues.indexOf(existing);
                if (index >= 0) fieldValues[index] = updated;
                else fieldValues.push(updated);
                found = true;
            });
        });
        if (found) updates.push({ appliedTemplateId: template.id, fieldValues });
    });
    return updates;
};
